export const defaultCompactField = { name: 'status', key: 'status' };

export const defaultAttributeFieldsKeys = {
  project: 1,
  issue_type: 2,
  assignee: 3,
  priority: 4,
  issuetype: 2,
  'issue type': 2,
};

export const ignoreFields = {
  summary: 1,
  attachment: 1,
  description: 1,
  comment: 1,
  subtasks: 1,
  worklog: 1,
  issuelinks: 1,
};

export const allowedSchemaTypes = (field) => {
  let allowedSchemaTypes = {
    string: 1,
    array: 1,
    number: 1,
    date: 1,
    issuetype: 1,
    issuelink: 1,
    project: 1,
    user: 1,
    priority: 1,
    datetime: 1,
    option: 1,
  };
  if (!field.schema) return false;
  if (
    field &&
    field.schema &&
    field.schema.type &&
    allowedSchemaTypes[field.schema.type]
  ) {
    return false;
  } else if (field.schema.custom === 'com.pyxis.greenhopper.jira:gh-epic-link')
    return false; /* EPIC LINK */

  return true;
};

const actionButtonOptions = () => {
  return [
    {
      name: 'View',
      value: 'jira_view_modal',
    },
    {
      name: 'Change Status',
      value: 'task_change_status_modal',
    },
    {
      name: 'Comment',
      value: 'task_comment_modal',
    },
    {
      name: 'Edit',
      value: 'task_edit_modal',
    },
    {
      name: 'Update Field(s)',
      value: 'update_fields',
    },
    {
      name: 'Assign to me',
      value: 'task_assign_to_me',
    },
    {
      name: 'Assign',
      value: 'assignee',
    },
    {
      name: 'Log Time',
      value: 'jira_issue_log_time_modal',
    },
    {
      name: 'Link Issue',
      value: 'link_issue',
    },
    {
      name: 'Labels',
      value: 'labels',
    },
    {
      name: 'Add sub task',
      value: 'create_subtask',
    },
    {
      name: 'Start/Stop Watching',
      value: 'start_stop_watching_issue',
    },
    {
      name: 'Show Activity',
      value: 'get_activity',
    },
    {
      name: 'Start Channel Sync',
      value: 'start_channel_sync',
    },
  ];
};

export { actionButtonOptions };

export const customButtons = () => {
  return [
    actionButtonOptions()[0],
    actionButtonOptions()[1],
    actionButtonOptions()[2],
  ];
};
